// React
import React from 'react'

// Components
import { CartPicker } from 'store/modules/cart/FloatingCart/components/CartPicker'
import CartButtonComponent from 'store/modules/cart/CartButton'

// Hooks
import { useSettings } from 'shared/utils/useSettings'

export const CartButton = (props) => {
  const isShowCartBehavior = useSettings('store.behaviors.add_button') === 'show_cart'

  return (
    <div className="booqable-component" style={{ display: 'none' }}>
      {isShowCartBehavior && <CartButtonComponent {...props} />}
      <CartPicker />
    </div>
  )
}

export default CartButton
